import { NgIf } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { PageToolbarComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';
import { BreakpointService, BreakpointServiceInjector } from '@next/core-lib/responsive';
import { take } from 'rxjs/operators';

import { WithinCyclePerformanceComponent } from '../../within-cycle-performance.component';
import { WithinCyclePerformanceOverviewSimpleComponent } from '../within-cycle-performance-overview-simple/within-cycle-performance-overview-simple.component';

@Component({
  selector: 'app-within-cycle-performance-overview',
  templateUrl: './within-cycle-performance-overview.component.html',
  styleUrls: [],
  imports: [
    PageToolbarComponent,
    MatSlideToggle,
    NgIf,
    WithinCyclePerformanceComponent,
    WithinCyclePerformanceOverviewSimpleComponent,
    TranslatePipe,
  ],
})
export class WithinCyclePerformanceOverviewComponent implements OnInit {
  private readonly breakpointService = inject<BreakpointService>(BreakpointServiceInjector);

  isMobile$ = this.breakpointService.ltSm$;

  isDetailedOverview = true;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnInit(): void {
    this.isMobile$.pipe(take(1)).subscribe((isMobile) => (this.isDetailedOverview = !isMobile));
  }

  toggleDetailedOverview() {
    this.isDetailedOverview = !this.isDetailedOverview;
  }
}
